export const SHARED_MASTERS_REGISTRY = {
  "ac-groups": {
    id: "ac-groups",
    title: "A/c Groups",
    category: "Financial Operations",
    desc: "Manage chart of accounts groups and main ledger classifications.",
    apiEndpoint: "/api/financials/ac-groups",
    tools: [
      { key: "download", label: "Download", icon: "download" },
      { key: "upload", label: "Upload", icon: "upload" }
    ],
    columns: ["Name", "Under"],
    data: {
      Active: [
        { id: 1, name: "Agents", under: "Current Liabilities" },
        { id: 2, name: "Assets", under: "Main" },
        { id: 3, name: "Bank Accounts", under: "Current Assets" },
        { id: 4, name: "Bank OD A/c", under: "Loans (Liability)" },
        { id: 5, name: "Branch / Divisions", under: "Assets" },
        { id: 6, name: "Capital Account", under: "Liability" },
        { id: 7, name: "Cash-in-hand", under: "Current Assets" },
        { id: 8, name: "Current Assets", under: "Assets" },
        { id: 9, name: "Current Liabilities", under: "Liability" },
        { id: 10, name: "DeliveryMan", under: "Current Liabilities" },
        { id: 11, name: "Deposits (Asset)", under: "Current Assets" },
        { id: 12, name: "Deposits (Liability)", under: "Current Liabilities" },
        { id: 13, name: "Direct Expenses", under: "Expense" },
        { id: 14, name: "Direct Incomes", under: "Income" },
        { id: 15, name: "Donor", under: "Current Liabilities" },
        { id: 16, name: "Duties & Taxes", under: "Current Liabilities" },
        { id: 17, name: "Employees", under: "Current Assets" },
        { id: 18, name: "Expense", under: "Main" },
        { id: 19, name: "Fixed Assets", under: "Assets" },
        { id: 20, name: "Fixed Deposit", under: "Investments" },
        { id: 21, name: "Income", under: "Main" },
        { id: 22, name: "Income & Expense A/c", under: "Assets" },
        { id: 23, name: "Indirect Expenses", under: "Expense" },
        { id: 24, name: "Indirect Incomes", under: "Income" },
        { id: 25, name: "Investments", under: "Assets" }
      ],
      Archive: [
        { id: 26, name: "Investments (Archived)", under: "Assets" },
        { id: 27, name: "Loans & Advances (Archived)", under: "Assets" },
        { id: 28, name: "Secured Loans (Archived)", under: "Liability" },
        { id: 29, name: "Unsecured Loans (Archived)", under: "Liability" }
      ]
    }
  },
  "customergroup": {
    id: "customergroup",
    title: "Customer Group",
    category: "Financial Operations",
    desc: "Configure customer groups and reporting nodes.",
    apiEndpoint: "/api/financials/customergroup",
    tools: [
      { key: "download", label: "Download", icon: "download" },
      { key: "upload-data", label: "Upload Data", icon: "upload" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Reserves & Surplus" },
        { id: 2, name: "Sundry Creditors" },
        { id: 3, name: "Bank Accounts" },
        { id: 4, name: "Cash-in-hand" },
        { id: 5, name: "Stock-in-hand" }
      ],
      Archive: [
        { id: 6, name: "Secured Loans (Archived)" },
        { id: 7, name: "Unsecured Loans (Archived)" }
      ]
    }
  },
  "inventory-group": {
    id: "inventory-group",
    title: "Inventory Group",
    category: "Financial Operations",
    desc: "Manage inventory groupings, product classifications, and stock divisions.",
    apiEndpoint: "/api/financials/inventory-groups",
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Raw Materials" },
        { id: 2, name: "Work in Progress" },
        { id: 3, name: "Finished Goods" },
        { id: 4, name: "Packaging Materials" }
      ],
      Archive: [
        { id: 5, name: "Scrap & Waste (Archived)" },
        { id: 6, name: "Consumable Spares (Archived)" }
      ]
    }
  },
  "boe-cha": {
    id: "boe-cha",
    title: "BOE CHA Master",
    category: "Financial Operations",
    desc: "Configure Bill of Entry Custom House Agent registries and regulatory records.",
    apiEndpoint: "/api/financials/boe-cha",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "CHA India Logistics" },
        { id: 2, name: "Global Customs Clearing" },
        { id: 3, name: "Express Cargo Agency" },
        { id: 4, name: "SafeGate Customs Services" }
      ],
      Archive: [
        { id: 5, name: "Legacy Customs Brokers (Archived)" }
      ]
    }
  },
  "boe-forwarder": {
    id: "boe-forwarder",
    title: "BOE Forwarder Master",
    category: "Financial Operations",
    desc: "Manage freight forwarders, shipping lines, and logistics partners.",
    apiEndpoint: "/api/financials/boe-forwarder",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Maersk Line" },
        { id: 2, name: "DHL Global Forwarding" },
        { id: 3, name: "FedEx Trade Networks" },
        { id: 4, name: "Kuehne + Nagel" }
      ],
      Archive: [
        { id: 5, name: "Apex Transporters (Archived)" }
      ]
    }
  },
  "place": {
    id: "place",
    title: "Place Master",
    category: "Organizational Structure",
    desc: "Configure geographical registries, locations, and office territories.",
    apiEndpoint: "/api/organization/places",
    tools: [
      { key: "download", label: "Download", icon: "download" },
      { key: "analytics", label: "Analytics", icon: "analytics" },
      { key: "upload", label: "Upload", icon: "upload" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Mumbai" },
        { id: 2, name: "Delhi" },
        { id: 3, name: "Bangalore" },
        { id: 4, name: "Hyderabad" },
        { id: 5, name: "Chennai" },
        { id: 6, name: "Kolkata" }
      ],
      Archive: [
        { id: 7, name: "Old Depot (Archived)" }
      ]
    }
  },
  "school-college": {
    id: "school-college",
    title: "School/College Master",
    category: "Organizational Structure",
    desc: "Manage academic institutions, affiliate colleges, and partner campuses.",
    apiEndpoint: "/api/organization/schools",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "St. Xavier's College" },
        { id: 2, name: "Delhi Public School" },
        { id: 3, name: "Indian Institute of Technology" },
        { id: 4, name: "Stanford University" },
        { id: 5, name: "National Public School" }
      ],
      Archive: [
        { id: 6, name: "Legacy Grammar Academy (Archived)" }
      ]
    }
  },
  "occupations": {
    id: "occupations",
    title: "Occupation Master",
    category: "Demographics & References",
    desc: "Manage occupational registries, job types, and professional mappings.",
    apiEndpoint: "/api/demographics/occupations",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Software Engineer" },
        { id: 2, name: "Doctor" },
        { id: 3, name: "Teacher" },
        { id: 4, name: "Business Owner" },
        { id: 5, name: "Student" },
        { id: 6, name: "Retired" }
      ],
      Archive: [
        { id: 7, name: "Stenographer (Archived)" }
      ]
    }
  },
  "relations": {
    id: "relations",
    title: "Relations",
    category: "Demographics & References",
    desc: "Configure relationship matrices, guardian classifications, and family roles.",
    apiEndpoint: "/api/demographics/relations",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Brother" },
        { id: 2, name: "Daughter" },
        { id: 3, name: "Sister" },
        { id: 4, name: "Son" },
        { id: 5, name: "Staff" }
      ],
      Archive: [
        { id: 6, name: "Spouse (Archived)" },
        { id: 7, name: "Guardian (Archived)" }
      ]
    }
  },
  "caste": {
    id: "caste",
    title: "Caste",
    category: "Demographics & References",
    desc: "Manage demographic classifications, social categories, and reference registers.",
    apiEndpoint: "/api/demographics/castes",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Buddhism" },
        { id: 2, name: "Christianity" },
        { id: 3, name: "Hinduism" },
        { id: 4, name: "Islam" },
        { id: 5, name: "Jainism" },
        { id: 6, name: "Sikhism" }
      ],
      Archive: [
        { id: 7, name: "Atheism (Archived)" }
      ]
    }
  },
  "project-master": {
    id: "project-master",
    title: "Project Master",
    category: "System Configuration",
    desc: "Manage enterprise project definitions, core task lists, and program registries.",
    apiEndpoint: "/api/configuration/projects",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Enterprise ERP Migration" },
        { id: 2, name: "CRM Integration" },
        { id: 3, name: "Cloud Security Upgrade" },
        { id: 4, name: "Data Warehouse Setup" }
      ],
      Archive: [
        { id: 5, name: "Internal Utility Tooling (Archived)" }
      ]
    }
  },
  "medium": {
    id: "medium",
    title: "Medium Master",
    category: "System Configuration",
    desc: "Configure communication and educational language mediums.",
    apiEndpoint: "/api/configuration/mediums",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "English" },
        { id: 2, name: "Hindi" },
        { id: 3, name: "Spanish" },
        { id: 4, name: "French" },
        { id: 5, name: "German" }
      ],
      Archive: [
        { id: 6, name: "Latin (Archived)" }
      ]
    }
  },
  "remarks-category": {
    id: "remarks-category",
    title: "Remark Category Master",
    category: "Content & Communication",
    desc: "Manage categorizations for system alerts, logs, and remarks.",
    apiEndpoint: "/api/configuration/remark-categories",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Performance Feedback" },
        { id: 2, name: "General Inquiry" },
        { id: 3, name: "System Alert" },
        { id: 4, name: "Billing Issue" }
      ],
      Archive: [
        { id: 5, name: "Obsolete Audit Remark (Archived)" }
      ]
    }
  },
  "contact-category": {
    id: "contact-category",
    title: "Contact Category Master",
    category: "Content & Communication",
    desc: "Configure contact classifications and stakeholder groups.",
    apiEndpoint: "/api/configuration/contact-categories",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "Vendor" },
        { id: 2, name: "Client" },
        { id: 3, name: "Employee" },
        { id: 4, name: "Partner" },
        { id: 5, name: "Prospect" }
      ],
      Archive: [
        { id: 6, name: "Blacklisted Entity (Archived)" }
      ]
    }
  },
  "boards": {
    id: "boards",
    title: "Boards Master",
    category: "System Configuration",
    desc: "Configure education boards and academic affiliations.",
    apiEndpoint: "/api/configuration/boards",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "CBSE (Central Board of Secondary Education)" },
        { id: 2, name: "ICSE (Indian Certificate of Secondary Education)" },
        { id: 3, name: "State Board of Maharashtra" },
        { id: 4, name: "Cambridge International Examinations" }
      ],
      Archive: [
        { id: 5, name: "Legacy Board (Archived)" }
      ]
    }
  },
  "sub-caste": {
    id: "sub-caste",
    title: "Sub-Caste Master",
    category: "Demographics & References",
    desc: "Manage sub-caste demographic classifications.",
    apiEndpoint: "/api/demographics/sub-castes",
    tools: [
      { key: "download", label: "Download", icon: "download" }
    ],
    columns: ["Action", "Name"],
    data: {
      Active: [
        { id: 1, name: "General" },
        { id: 2, name: "OBC - Creamy Layer" },
        { id: 3, name: "OBC - Non-Creamy Layer" },
        { id: 4, name: "SC (Scheduled Caste)" },
        { id: 5, name: "ST (Scheduled Tribe)" }
      ],
      Archive: [
        { id: 6, name: "Unspecified (Archived)" }
      ]
    }
  }
};

// Singular & Plural Aliases to prevent any 404 mismatch
SHARED_MASTERS_REGISTRY["ac-group"] = SHARED_MASTERS_REGISTRY["ac-groups"];
SHARED_MASTERS_REGISTRY["groups"] = SHARED_MASTERS_REGISTRY["customergroup"];
SHARED_MASTERS_REGISTRY["group"] = SHARED_MASTERS_REGISTRY["customergroup"];
SHARED_MASTERS_REGISTRY["customer-group"] = SHARED_MASTERS_REGISTRY["customergroup"];
SHARED_MASTERS_REGISTRY["customergroups"] = SHARED_MASTERS_REGISTRY["customergroup"];
SHARED_MASTERS_REGISTRY["inventory-groups"] = SHARED_MASTERS_REGISTRY["inventory-group"];
SHARED_MASTERS_REGISTRY["boe-cha-master"] = SHARED_MASTERS_REGISTRY["boe-cha"];
SHARED_MASTERS_REGISTRY["boe-forwarder-master"] = SHARED_MASTERS_REGISTRY["boe-forwarder"];
SHARED_MASTERS_REGISTRY["place-master"] = SHARED_MASTERS_REGISTRY["place"];
SHARED_MASTERS_REGISTRY["school-collage"] = SHARED_MASTERS_REGISTRY["school-college"];
SHARED_MASTERS_REGISTRY["school-college-master"] = SHARED_MASTERS_REGISTRY["school-college"];
SHARED_MASTERS_REGISTRY["occupation"] = SHARED_MASTERS_REGISTRY["occupations"];
SHARED_MASTERS_REGISTRY["relation"] = SHARED_MASTERS_REGISTRY["relations"];
SHARED_MASTERS_REGISTRY["castes"] = SHARED_MASTERS_REGISTRY["caste"];
SHARED_MASTERS_REGISTRY["projects"] = SHARED_MASTERS_REGISTRY["project-master"];
SHARED_MASTERS_REGISTRY["project"] = SHARED_MASTERS_REGISTRY["project-master"];
SHARED_MASTERS_REGISTRY["mediums"] = SHARED_MASTERS_REGISTRY["medium"];
SHARED_MASTERS_REGISTRY["remark-category"] = SHARED_MASTERS_REGISTRY["remarks-category"];
SHARED_MASTERS_REGISTRY["contact-categories"] = SHARED_MASTERS_REGISTRY["contact-category"];
SHARED_MASTERS_REGISTRY["contact-category-master"] = SHARED_MASTERS_REGISTRY["contact-category"];
SHARED_MASTERS_REGISTRY["board"] = SHARED_MASTERS_REGISTRY["boards"];
SHARED_MASTERS_REGISTRY["boards-master"] = SHARED_MASTERS_REGISTRY["boards"];
SHARED_MASTERS_REGISTRY["subcaste"] = SHARED_MASTERS_REGISTRY["sub-caste"];
SHARED_MASTERS_REGISTRY["sub-caste-master"] = SHARED_MASTERS_REGISTRY["sub-caste"];
